(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zg-showroom-trust"] && !Shopify.designMode) return;
  try {
    if (!window.zgLocalDrawerBound) {
 window.zgLocalDrawerBound = true;
 document.addEventListener('click', event => {
  const open = event.target.closest('[data-zg-open]');
  if (open) {
   const dialog = open.closest('.zg-team').nextElementSibling;
   if (!dialog || !dialog.matches('.zg-local-drawer')) return;
   if (!dialog.dataset.bound) {
    dialog.dataset.bound='true';
    dialog.addEventListener('close',()=>{dialog.querySelector('video')?.pause();open.focus({preventScroll:true});});
    dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
   }
   dialog.showModal();
  }
  const close=event.target.closest('[data-zg-close]');
  if(close) close.closest('dialog').close();
 });
}
  } catch(e) { console.error(e); }
})();

})();
